import React from "react";
import PropTypes from "prop-types";
import SearchForm from "../../../dataentry/lib/search/views/SearchForm";
import RecordSourceSelection from "./RecordSourceSelection";

export class RecordSourcePluginView extends React.Component {

    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(e) {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    render() {
        const { fluxContext, onTypeChange, fields, typeOptions } = this.props;

        if (fluxContext == null || fields == null) {
            console.warn("RecordSourcePluginView was passed no data.");
            return null;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-3">
                        <RecordSourceSelection onChange={onTypeChange} options={typeOptions} />
                    </div>
                    <div className="col-md-6">
                        {fields.length > 0 && <SearchForm
                            fluxContext={fluxContext}
                            alwaysShowAdvanced={true}
                            onSubmit={this.onFormSubmit}
                        />}
                    </div>
                </div>
                {fields.length > 0 && <div className="row">
                    <div className="col-md-12">
                        <button onSubmit={this.onFormSubmit} onClick={this.onFormSubmit} type="submit" className="btn btn-search">
                            <span></span> Search
                        </button>
                    </div>
                </div>}
            </div>
        );
    }

}

RecordSourcePluginView.propTypes = {
    fluxContext: PropTypes.string,
    fields: PropTypes.array,
    onSubmit: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    typeOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcepluginview/RecordSourcePluginView.js